import { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { ArrowLeft, Lock } from 'lucide-react';

import { AuthShell } from './AuthShell';
import { OtpInput } from './components/OtpInput';
import styles from './auth.module.css';

const ROTATION_S = 30;

// TODO(Phase 1): replace stub with real MFA enrollment via
// supabase.auth.mfa.challenge() + verify(). Phase 0 only validates length=6.
export function TwoFAScreen() {
  const navigate = useNavigate();
  const [code, setCode] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [formError, setFormError] = useState<string | null>(null);
  const [seconds, setSeconds] = useState(ROTATION_S);

  useEffect(() => {
    const t = setInterval(() => {
      setSeconds((s) => (s <= 1 ? ROTATION_S : s - 1));
    }, 1000);
    return () => { clearInterval(t); };
  }, []);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setFormError(null);
    if (code.length !== 6 || !/^\d{6}$/.test(code)) {
      setFormError('הקוד חייב 6 ספרות');
      return;
    }
    setSubmitting(true);
    // STUB: real verify in Phase 1.
    await new Promise((r) => setTimeout(r, 300));
    setSubmitting(false);
    navigate('/');
  };

  const valid = code.length === 6 && /^\d{6}$/.test(code);

  return (
    <AuthShell
      title="אימות דו-שלבי"
      subtitle="הזן את הקוד מאפליקציית Authenticator"
      brandSide={{
        title: 'אבטחה בכל שלב',
        body: 'החשבון שלך מוגן ב-2FA · הקוד מתחלף כל 30 שניות.',
      }}
    >
      <form className={styles.form} onSubmit={onSubmit} noValidate>
        <div className={styles.twoFaIllust}>
          <Lock size={28} />
          <small>קוד מ-Google Authenticator</small>
        </div>

        <OtpInput value={code} onChange={setCode} invalid={!!formError} autoFocus />

        <div className={styles.otpMeta}>
          <small>
            הקוד מתחלף בעוד <strong className="num">{String(seconds)}</strong> שנ׳
          </small>
          <button
            type="button"
            className={styles.linkMini}
            onClick={() => { console.warn('SMS fallback ב-Phase 1'); }}
            disabled
            title="זמין ב-Phase 1"
          >
            שלח קוד ב-SMS
          </button>
        </div>

        {formError ? <p className={styles.formError}>{formError}</p> : null}

        <button type="submit" className={styles.primary} disabled={!valid || submitting}>
          אמת והמשך
          <ArrowLeft size={14} className="flip-rtl" />
        </button>

        <Link to="/auth/login" className={styles.back}>
          <ArrowLeft size={12} className="flip-rtl" />
          חזור להתחברות
        </Link>
      </form>
    </AuthShell>
  );
}
